module.exports = __webpack_public_path__ + "img/Primordial-Process-7-mobile.4b75a3c7.png";